import { useDroppable } from '@dnd-kit/core';
import { Camera, CameraGroupCamera } from '@hakimo-ui/hakimo/types';
import DraggableCameraItem from './DraggableCameraItem';

interface Props {
  cameras: CameraGroupCamera[];
  cameraMap: Map<string, Camera>;
  onRemove: (cam: CameraGroupCamera) => void;
}

function SelectedCamerasCard({ cameras, cameraMap, onRemove }: Props) {
  const { setNodeRef } = useDroppable({
    id: 'selected-drop-zone',
  });

  return (
    <div
      ref={setNodeRef}
      className="bg-onlight-bg-1 dark:bg-ondark-bg-1 flex max-h-[36rem] flex-col rounded-xl p-4"
    >
      <p className="dark:text-onlight-bg-2 text-onlight-text-1 mb-4 px-2 font-medium">
        Selected Cameras
      </p>

      <div className="flex-1 space-y-3 overflow-y-auto">
        {cameras.length === 0 && (
          <div className="flex items-center justify-center">
            <p className="text-onlight-text-3 px-4 py-36 text-center text-sm">
              No cameras added to this group yet
            </p>
          </div>
        )}

        {cameras.map((cam) => (
          <DraggableCameraItem
            key={cam.id}
            cam={cam}
            id={cam.id}
            name={cam.name}
            imageUrl={cameraMap.get(cam.id)?.imageUrl}
            livestreamUrl={cameraMap.get(cam.id)?.livestreamUrl}
            showCancelButton
            onCancel={onRemove}
          />
        ))}
      </div>
    </div>
  );
}

export default SelectedCamerasCard;
